import(/* webpackMode: "eager" */ "/app/apps/planner/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/app/layout.module.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/assets/img/bmAdAstraLogo.png");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/assets/img/bmAdAstraLogoWhite.png");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/components/app-header/app-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/apps/planner/src/lib/metrics/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HotjarAnalytics"] */ "/app/apps/planner/src/lib/metrics/hotjar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/providers/apollo-client-provider/apollo-client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/providers/auth-provider/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagProvider"] */ "/app/apps/planner/src/providers/feature-flag-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/providers/modal-provider/modal-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MSWProvider"] */ "/app/apps/planner/src/providers/msw-provider/msw-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/providers/theme-provider/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/planner/src/utils/dayjs-config.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@mui+material-nextjs@7.3.6_@emotion+cache@11.14.0_@emotion+react@11.14.0_@types+react@19.2.7__boo2yw6gpoxrisgytnq7daqohq/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.2.7_react@19.2.3__@emotion+styled@_ssoaj7n73gn6eog2jwrriqffqq/node_modules/@mui/material/esm/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager" */ "/app/packages/cc-ds/dist/assets/fonts/proxima-nova-a/proxima-nova-a.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppFooter"] */ "/app/packages/cc-ds/dist/components/app-footer/app-footer.component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/providers/snackbar-provider/snackbar-provider.tsx");
